<template>
  <div>
    <AlarmLayout />
    <router-view></router-view>
  </div>
</template>

<script setup>
import "@/assets/css/alarm.css";
import AlarmLayout from "@/components/alarm/common/AlarmLayout.vue";
</script>
